/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React from 'react';
import { IconContext } from 'react-icons';
import PropTypes from 'prop-types';
import styled, { ThemeProvider } from 'styled-components';

import { SideNav } from './sideNav';
import './layout.css';
import { theme, darkPalette, lightPalette } from '@style';
import { useSelector } from 'react-redux';

const Container = styled.div`
  display: grid;
  grid-template-columns: 280px 1fr;
  font-family: ${theme.fontNormal400};
`;

const Main = styled.main<{ isDarkMode: boolean }>`
  height: 100vh;
  background: ${props =>
    props.isDarkMode ? theme.palette.dtGray : theme.palette.white};
  overflow: overlay;
`;

const Layout = ({ children }) => {
  const isDarkMode: boolean = useSelector(state => state.app.isDarkMode);

  return (
    <IconContext.Provider value={{ style: { verticalAlign: 'middle' } }}>
      <ThemeProvider theme={isDarkMode ? darkPalette : lightPalette}>
        <Container>
          <SideNav />
          <Main isDarkMode={isDarkMode}>{children}</Main>
        </Container>
      </ThemeProvider>
    </IconContext.Provider>
  );
};

Layout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Layout;
